import { Button, classes, icons } from '@portal/components'
import React from 'react'

const { SideBarOpenInverse, SideBarOpen } = icons

export type SideBarToggleProps = {
  side: 'left' | 'right'
  open: boolean
  openHandler: () => void
  children?: React.ReactNode
}

export default function SideBarOpener({
  side = 'left',
  children,
  open,
  openHandler,
}: SideBarToggleProps) {
  const Icon = side === 'left' ? SideBarOpen : SideBarOpenInverse

  return (
    <div
      className={classes(
        'flex items-center gap-x-2 transition-transform duration-200 ease-in-out md:max-w-xs',
        {
          '-translate-x-12 gap-x-4': open && side === 'left',
          'translate-x-12 gap-x-4': open && side === 'right',
        },
      )}
    >
      <Button
        variant="ghost"
        size="square"
        className={classes(
          'visible order-1 text-foreground-subtle opacity-100 transition-transform duration-200 ease-in-out',
          {
            'order-2': side === 'right',
            'invisible opacity-0': open,
          },
        )}
        aria-label={`Toggle ${side} sidebar`}
        onClick={openHandler}
      >
        <Icon
          aria-hidden="true"
          className="size-4"
          data-testid={`icon-${side}`}
        />
      </Button>

      <div className={classes('order-2', { 'order-1': side === 'right' })}>
        {children}
      </div>
    </div>
  )
}
